import { Navigate, Route, Routes } from 'react-router-dom'
import { DashboardPage } from '../modules/dashboard/DashboardPage'
import { LoginPage } from '../modules/identity/LoginPage'
import { ProtectedRoute } from '../modules/identity/ProtectedRoute'
import { SignUpPage } from '../modules/identity/SignUpPage'
import { OnboardingGate } from '../modules/onboarding/OnboardingGate'
import { OnboardingPage } from '../modules/onboarding/OnboardingPage'
import { LegalPage } from '../modules/onboarding/LegalPage'
import { LandingPage } from '../modules/marketing/LandingPage'
import { AppLayout } from '../modules/dashboard/AppLayout'
import { ContactsPage } from '../modules/contacts/ContactsPage'
import { CatalogPage } from '../modules/catalog/CatalogPage'
import { QuotesPage } from '../modules/quotes/QuotesPage'
import { ComponentsPage } from '../modules/components/ComponentsPage'
import { BillingPage } from '../modules/billing/BillingPage'

export function App() {
  return (
    <Routes>
      <Route path="/entrar" element={<LoginPage />} />
      <Route path="/cadastro" element={<SignUpPage />} />
      <Route path="/legal/terms" element={<LegalPage type="terms" />} />
      <Route path="/legal/privacy" element={<LegalPage type="privacy" />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route element={<OnboardingGate />}>
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="catalog" element={<CatalogPage />} />
            <Route path="components" element={<ComponentsPage />} />
            <Route path="quotes" element={<QuotesPage />} />
            <Route path="billing" element={<BillingPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
